import React from "react";
import DownloadModal from "components/pages/transmissions/modal/download/DownloadModal";
import ProcessModal from "components/pages/transmissions/modal/process/ProcessModal";
import SigningModal from "components/pages/transmissions/modal/sign/SignModal";
import Hl7JobModal from "components/pages/transmissions/modal/hl7job/hl7JobModal";

import BillingModal from "components/pages/transmissions/modal/billing/BillingModal";
import EditNextSendModal from "components/pages/transmissions/modal/next_send/NextSendModal";
import PhysicianModal from "components/pages/transmissions/modal/physician/PhysicianModal";

import PatientModal from "components/pages/transmissions/modal/patient/PatientModal";
import ReportDetailModal from "components/pages/transmissions/modal/detail/ReportDetailModal";
import { useSelector } from "react-redux";
import ArchiveModal from "./archive/ArchiveModal";
import SignProcessModal from "./sign-process/SignProcessModal";

const TransmissionModals = ({ setRowSelection }) => {
  const {
    isNextSendModal,
    isPatientModal,
    isReportDetailModal,
    isPhysicianModal,
    isSignAndProcessModal,
    isHl7JobModal,
  } = useSelector((state) => state.transmission);

  return (
    <>
      <DownloadModal />
      <ProcessModal setRowSelection={setRowSelection} />
      <ArchiveModal setRowSelection={setRowSelection} />
      <SigningModal setRowSelection={setRowSelection} />
      <BillingModal setRowSelection={setRowSelection} />
      {isNextSendModal && <EditNextSendModal />}
      {isPhysicianModal && <PhysicianModal />}
      {isPatientModal && <PatientModal />}
      {isReportDetailModal && <ReportDetailModal />}
      {isHl7JobModal && <Hl7JobModal setRowSelection={setRowSelection} />}
      {isSignAndProcessModal && (
        <SignProcessModal setRowSelection={setRowSelection} />
      )}
    </>
  );
};

export default TransmissionModals;
